module.exports = __webpack_public_path__ + "img/st_tab2.d52f10aa.png";